/*
 * Copyright (c) 2020 NOOGA DEVELOPMENT, All rights reserved.
 * Author Raman Kremko <raman.kremko@noogadev.com>
 */

import { CircularProgress } from '@mui/material';
import { Theme } from '@mui/material/styles';

import createStyles from '@mui/styles/createStyles';
import makeStyles from '@mui/styles/makeStyles';

const PreloaderStyles = makeStyles((theme: Theme) =>
    createStyles({
        wrapper: {
            position: 'fixed',
            top: 0,
            right: 0,
            bottom: 0,
            left: 0,
            backgroundColor: 'black',
            opacity: 0.3,
            zIndex: 9999,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
        },
        loader: {
            color: 'white',
        },
        boxPreloaderWrapper: {
            width: '100%',
            height: '100%',
            zIndex: 9999,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
        },
        boxLoader: {
            color: theme.palette.primary.main,
        },
    }),
);

interface PreloaderOwnProps {
    isLoading: boolean;
    isInBox?: boolean;
}

const Preloader = (props: PreloaderOwnProps) => {
    const { isLoading, isInBox } = props;

    const classes = PreloaderStyles();

    if (!isLoading) {
        return null;
    }

    if (isInBox) {
        return (
            <div data-testid="ui-preloader-box" className={classes.boxPreloaderWrapper}>
                <CircularProgress className={classes.boxLoader} />
            </div>
        );
    }

    return (
        <div data-testid="ui-preloader-fullscreen" className={classes.wrapper}>
            <CircularProgress size={50} className={classes.loader} />
        </div>
    );
};

export default Preloader;
